export const wtmdata = JSON.parse(localStorage.getItem('wtmdata')) || null;
